import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { Illustration } from 'frontend-utils';
import ErnestSymbol from 'lumen/assets/images/logos/ernest-symbol.svg?raw';
import ENV from 'lumen/config/environment';

import styles from './ernest-navigation-button.module.css';

interface HotelAndMarketNavigationErnestNavigationButtonSignature {
  Args: {};
  Element: HTMLAnchorElement;
}

export default class HotelAndMarketNavigationErnestNavigationButton extends Component<HotelAndMarketNavigationErnestNavigationButtonSignature> {
  @service declare usageAnalytics: Services['usage-analytics'];

  @action trackOpen(): void {
    this.usageAnalytics.track('Ernest Opened', {
      eventTrigger: 'navigation-ernest-button',
    });
  }

  <template>
    <a
      class="prism-button prism-button--ghost
        {{styles.ernest-navigation-button}}"
      data-test-id="ernest-navigation-button"
      href={{ENV.ernestURL}}
      rel="noopener noreferrer"
      target="_blank"
      {{on "click" this.trackOpen}}
      ...attributes
    >
      <Illustration @html={{ErnestSymbol}} class={{styles.symbol}} />

      <span data-test-id="ernest-label">{{t "general.ernest"}}</span>
    </a>
  </template>
}
